package br.com.texeratx.boardgametimeapp.core.i18n

enum class AppLanguage(val code: String, val displayName: String) {
    PT("pt", "Português"),
    EN("en", "English")
}
